import React, {useState, useEffect} from 'react';
import {Row, Col, Table, Button, Modal, Input, Select, DatePicker, Form} from 'antd'
import moment from 'moment'
import { useTranslation } from 'react-i18next';
import { validateRutHelper } from "../../../../../../helpers";

const TIPO_DOC_BASE = new Set(['RUT', 'OTRO'])
const TIPO_REL_BASE = new Set(['REP_LEGAL', 'DIRECTOR', 'GERENTE_GENERAL', 'EJ_PRINCIPAL', 'AVAL', 'APODERADO'])

const TIPO_REL_MAP = {
    'rep_legal':            'REP_LEGAL',
    'rep. legal':           'REP_LEGAL',
    'rep.legal':           'REP_LEGAL',
    'representante legal':  'REP_LEGAL',
    'representantelegal':  'REP_LEGAL',
    'representante_legal':  'REP_LEGAL',
    'director':             'DIRECTOR',
    'gerente':              'GERENTE_GENERAL',
    'gerente general':      'GERENTE_GENERAL',
    'gerentegeneral':      'GERENTE_GENERAL',
    'gerente_general':      'GERENTE_GENERAL',
    'ejecutivo principal':  'EJ_PRINCIPAL',
    'ejecutivoprincipal':  'EJ_PRINCIPAL',
    'ejecutivo_principal':  'EJ_PRINCIPAL',
    'ej_principal':         'EJ_PRINCIPAL',
    'ej. principal':        'EJ_PRINCIPAL',
    'ej.principal':        'EJ_PRINCIPAL',
    'aval':                 'AVAL',
    'aval o coaval':        'AVAL',
    'avalocoaval':        'AVAL',
    'apoderado':            'APODERADO',
}

const isInTipoRelBase = (val) =>
    [...TIPO_REL_BASE].some(base => base.toLowerCase() === val.toLowerCase())

const Relacionados = ({ mode, repLegales, setRepLegales, currentUser, countries, form, setValidateRelacionados }) => {

    const { t } = useTranslation();
    const NEW_RELATED = "NEW_RELATED"

    const { getFieldDecorator, validateFields } = form || {};

    const [extraTipoDoc, setExtraTipoDoc] = useState([])
    const [showListRelEntidad, setShowListRelEntidad] = useState(false)
    const [showListTipoDoc, setShowListTipoDoc] = useState(false)
    const [indexRelated, setIndexRelated] = useState(-1)
    const [indexTipoDoc, setIndexTipoDoc] = useState(-1)
    const [newRelEntidad, setNewRelEntidad] = useState(null)
    const [newTipoDoc, setNewTipoDoc] = useState(null)
    const [lastAddedRelated, setLastAddedRelated] = useState(-1)
    const [extraRelEntidad, setExtraRelEntidad] = useState([])

    useEffect(() => {
        const fromDataTipoDoc = (repLegales || [])
            .map(r => TIPO_DOC_BASE[r.tipoDoc] || r.tipoDoc)
            .filter(t => t && !TIPO_DOC_BASE.has(t?.toUpperCase()) && t !== NEW_RELATED)

        if (fromDataTipoDoc.length > 0) {
            setExtraTipoDoc(prev => {
                const joinTipoDoc = [...prev]
                fromDataTipoDoc.forEach(item => {
                    if (!joinTipoDoc.some(p => p.toLowerCase() === item.toLowerCase())) {
                        joinTipoDoc.push(item)
                    }
                })
                return joinTipoDoc
            })
        }

        const fromDataRelated = (repLegales || [])
            .map(r => TIPO_REL_MAP[r.type] || r.type)
            .filter(t => t && !isInTipoRelBase(t) && t !== NEW_RELATED)

        if (fromDataRelated.length > 0) {
            setExtraRelEntidad(prev => {
                const joinRelEntidad = [...prev]
                fromDataRelated.forEach(item => {
                    if (!joinRelEntidad.some(p => p.toLowerCase() === item.toLowerCase())) {
                        joinRelEntidad.push(item)
                    }
                })
                return joinRelEntidad
            })
        }
    }, [repLegales])

    useEffect(() => {
        if (setValidateRelacionados && validateFields) {
            setValidateRelacionados(validateFields);
        }
    }, [validateFields, setValidateRelacionados])

    useEffect(() => {
        if (lastAddedRelated >= 0 && validateFields) {
            validateFields(
                [`name_${lastAddedRelated}`, `tipoDoc_${lastAddedRelated}`, `dni_${lastAddedRelated}`, `type_${lastAddedRelated}`],
                { force: true }
            );
            setLastAddedRelated(-1);
        }
    }, [lastAddedRelated, validateFields])

    const handleChangeRepLegal = (field, value, index) => {
        let rL = [ ...repLegales ]
        rL[index][field] = value
        rL[index].isBlank = false

        const tipo = rL[index].tipoDoc && String(rL[index].tipoDoc).toUpperCase() === 'RUT'
        if (tipo && rL[index].dni && currentUser?.cliente?.pais === 'CHI') {
            rL[index].isValid = validateRutHelper(String(rL[index].dni).trim())
        } else {
            rL[index].isValid = true
        }

        if(field === 'type') {
            if (value === NEW_RELATED) {
                rL[index][field] = null
                setShowListRelEntidad(true)
            }
        }
        if(field === 'tipoDoc') {
            if (value === NEW_RELATED) {
                rL[index][field] = null
                setShowListTipoDoc(true)
                setIndexTipoDoc(index)
            }
        }
            setRepLegales(rL)
            setIndexRelated(index)
    }

    const handleRemoveRepLegal = (index) => {
        if(repLegales.length > 0) {
            if (form && form.resetFields) {
                form.resetFields([`name_${index}`, `tipoDoc_${index}`, `dni_${index}`, `type_${index}`, `email_${index}`]);
            }
            let rL = [ ...repLegales ]
            rL.splice(index, 1)
            setRepLegales(rL)
        }
    }

    const handleNewRepLegal = () => {
        let rL = [ ...repLegales ]
        const newIndex = rL.length
        rL.push({isBlank: false, isValid: false})
        setRepLegales(rL)
        setLastAddedRelated(newIndex)
    }

    const getTableColumns = () => {
        const relatedTableColumns = [
        {
            title: `${t('messages.aml.name')} *`,
            dataIndex: 'name',
            render: (text, record, index) => {
            if(mode === 'view') {
                return text
            }else {
                return (
                <Form.Item style={{ marginBottom: 0 }}>
                    { getFieldDecorator && getFieldDecorator(`name_${index}`, {
                        rules: [{ required: true, message: t('messages.validation.required') }],
                        initialValue: text
                    })(
                        <Input style={{width: '100%'}} onChange={ (e) => handleChangeRepLegal('name', e.target.value, index) } maxLength={255}/>
                    )}
                </Form.Item>
                )
            }
            }
        },
        {
            title: `${t('messages.aml.dniType')} *`,
            dataIndex: 'tipoDoc',
            render: (text, record, index) => {
            if(mode === 'view') {
                return text
            }else {
                return(
                <Form.Item>
                    { getFieldDecorator && getFieldDecorator(`tipoDoc_${index}`, {
                        rules: [
                            { required: true, message: t('messages.validation.required') },
                            { validator: (_, value, callback) => {
                                if (value === NEW_RELATED) callback(t('messages.validation.required'));
                                else callback();
                            }}
                        ],
                        initialValue: text && TIPO_DOC_BASE.has(text.toUpperCase()) ? text.toUpperCase() : text
                    })(
                        <Select style={{width: '100%'}} onChange={ (value) => {
                            handleChangeRepLegal('tipoDoc', value, index);
                            if (form && form.validateFields) {
                                form.validateFields([`dni_${index}`], { force: true });//en onChange forzará validación de rut
                            }
                        }}>
                            <Select.Option value="RUT">{ t('messages.aml.rut') }</Select.Option>
                            <Select.Option value="OTRO">{ t('messages.aml.other') }</Select.Option>
                            { extraTipoDoc.map((opt) => (
                                <Select.Option key={opt} value={opt}>{opt}</Select.Option>
                            )) }
                            <Select.Option value={NEW_RELATED}>{t('messages.aml.newItem')}</Select.Option>
                        </Select>
                    )}
                </Form.Item>
                )
            }
            }
        },
        {
            title: `${t('messages.aml.dniLarge')} *`,
            dataIndex: 'dni',
            render: (text, record, index) => {
            if(mode === 'view') {
                return text
            }else {
                return (
                    <Form.Item>
                        { getFieldDecorator && getFieldDecorator(`dni_${index}`, {
                            rules: [
                                { required: true, message: t('messages.validation.required') },
                                {
                                    validator: (rule, value, callback) => {
                                        if (record.tipoDoc === 'RUT' && value && currentUser.cliente.pais === 'CHI' && !validateRutHelper(value)) {
                                            callback(t('messages.aml.invalidIdentityDocument'));
                                        } else {
                                            callback();
                                        }
                                    }
                                }
                            ],
                            initialValue: text
                        })(
                            <Input style={{width: '100%'}} onChange={ (e) => handleChangeRepLegal('dni', e.target.value, index) } maxLength={20}/>
                        )}
                    </Form.Item>
                )
            }
            }
        },
        {
            title: `${t('messages.aml.entityRelation')} *`,
            dataIndex: 'type',
            render: (text, record, index) => {
                if(mode === 'view') {
                    return text
                }else {
                    return(
                    <Form.Item>
                        { getFieldDecorator && getFieldDecorator(`type_${index}`, {
                            rules: [
                                { required: true, message: t('messages.validation.required') },
                                { validator: (_, value, callback) => {
                                    if (value === NEW_RELATED) callback(t('messages.validation.required'));
                                    else callback();
                                }}
                            ],
                            initialValue: TIPO_REL_MAP[text] || text
                        })(
                            <Select style={{width: '100%'}} onChange={ (value) => handleChangeRepLegal('type', value, index) }>
                                <Select.Option value="REP_LEGAL">{t('messages.aml.repLegal')}</Select.Option>
                                <Select.Option value="DIRECTOR">{t('messages.aml.director')}</Select.Option>
                                <Select.Option value="GERENTE_GENERAL">{t('messages.aml.manager')}</Select.Option>
                                <Select.Option value="EJ_PRINCIPAL">{t('messages.aml.executivePrincipal')}</Select.Option>
                                <Select.Option value="AVAL">{t('messages.aml.guarantor')}</Select.Option>
                                <Select.Option value="APODERADO">{t('messages.aml.attorney')}</Select.Option>
                                { extraRelEntidad.map((opt) => (
                                    <Select.Option key={opt} value={opt}>{opt}</Select.Option>
                                )) }
                                <Select.Option value={NEW_RELATED}>{t('messages.aml.newItem')}</Select.Option>
                            </Select>
                        )}
                    </Form.Item>
                    )
                }
            }
        },
        {
            title: t('messages.aml.email'),
            dataIndex: 'email',
            render: (text, record, index) => {
            if(mode === 'view') {
                return text
            }else {
                return (
                <Form.Item>
                    { getFieldDecorator && getFieldDecorator(`email_${index}`, {
                        rules: [
                            {
                                type: 'email',
                                message: t('messages.aml.emailNotValid')
                            },
                            {
                                max: 200,
                                message: t('messages.aml.errors.maxLength200')
                            }
                        ],
                        initialValue: text
                    })(
                        <Input style={{width: '100%'}} onChange={ (e) => handleChangeRepLegal('email', e.target.value, index) } maxLength={200}/>
                    )}
                </Form.Item>
                )
            }
            }
        },
        {
            title: t('messages.aml.nationality'),
            dataIndex: 'citizenship',
            render: (text, record, index) => {
            if(mode === 'view') {
                return text
            }else {
                return (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select
                            showSearch
                            defaultValue={ text }
                            style={{width: '100%'}}
                            onChange={ (value) => handleChangeRepLegal('citizenship', value, index) }
                            allowClear
                            >
                            { countries.map((country) => (
                                <Select.Option key={`${country.iso2 || ''}-${country.country}`} value={country.country}>{country.country}</Select.Option>
                            )) }
                        </Select>
                </Form.Item>
                )
            }
            }
        },
        {
            title: t('messages.aml.birthDate'),
            dataIndex: 'dateBirth',
            render: (text, record, index) => {
            if(mode === 'view') {
                return text
            }else {
                return (
                <Form.Item style={{ marginBottom: 0 }}>
                    <DatePicker
                            placeholder={t('messages.aml.birthDatePlaceholder')}
                            style={{width: '100%'}}
                            format="DD/MM/YYYY"
                            defaultValue={ text ? moment(text, "DD/MM/YYYY") : null }
                            onChange={(momentObj) =>
                            handleChangeRepLegal(
                                "dateBirth",
                                momentObj !== null
                                ?
                                moment(momentObj).format("DD/MM/YYYY")
                                : null,
                                index
                            )
                            }
                        />
                </Form.Item>
                )
            }
            }
        },
        {
            title: t('messages.aml.residenceCountry'),
            dataIndex: 'residentOf',
            render: (text, record, index) => {
            if(mode === 'view') {
                return text
            }else {
                return (
                <Form.Item style={{ marginBottom: 0 }}>
                    <Select
                            showSearch
                            defaultValue={ text }
                            style={{width: '100%'}}
                            onChange={ (value) => handleChangeRepLegal('residentOf', value, index) }
                            allowClear
                            >
                            { countries.map((country) => (
                                <Select.Option key={`${country.iso2 || ''}-${country.country}`} value={country.country}>{country.country}</Select.Option>
                            )) }
                        </Select>
                </Form.Item>
                )
            }
            }
        }
        ]
        if(currentUser.type !== 'AUDIT1' && mode !== 'view') {
            relatedTableColumns.push(
                {
                    dataIndex: 'id',
                    width: 50,
                    render: (text, record, index) => {
                        if (mode !== 'view') {
                            return <Button type="primary" icon="close" size="small" onClick={() => handleRemoveRepLegal(index)} />
                        }
                    }
                }
            )
        }
        return relatedTableColumns
    }

    return (
        <Form>
            <div>
                <Row className="field-section-row">
                    <Col span={24}>
                    <h3>
                        { t('messages.aml.related') }
                    </h3>
                    </Col>
                </Row>
                { mode !== 'view' &&
                    <Row style={{ padding: '0 10px 6px 10px', color: 'rgba(0,0,0,.65)', fontSize: 12 }}>
                        <Col span={24}>
                            <span><b>*</b> Campos obligatorios (nombre, tipo y número de documento, relación). El guardado valida esta sección antes de enviar.</span>
                        </Col>
                    </Row>
                }
                <hr/>
                <Row style={{padding: 10}}>
                    <Col xs={ 24 }>
                    <Table
                        className="tbl-related"
                        dataSource={ repLegales }
                        columns={ getTableColumns() }
                        pagination={ false } size='small'
                        rowClassName={(record) => {return record.isValid === false && record.isBlank === false ? 'no-valid' : ''}} />
                    </Col>
                </Row>
                { mode !== 'view' && currentUser.type !== 'AUDIT' &&
                    <Row>
                    <Col xs={ 24 }>
                        <Button type="primary" icon="plus" size="small" onClick={ () => {handleNewRepLegal()} } className="btn-add-replegal">
                        { t('messages.aml.addRelated') }
                        </Button>
                    </Col>
                    </Row>
                }
                { showListRelEntidad &&
                    <Modal
                        title={t('messages.aml.entityRelationTitle')}
                        className="modal-area-cliente"
                        visible={ true }
                        width={ 400 }
                        onOk={() => {
                            const rawValue = newRelEntidad?.trim()
                            if (!rawValue) return;

                            const baseMatch = [...TIPO_REL_BASE].find(b => b.toLowerCase() === rawValue.toLowerCase())//Busca en listado texto coinside ignore case
                            const labelMatch = TIPO_REL_MAP[rawValue.toLowerCase()] //buscará en nuevo mapa de sinonimos TIPO_REL_MAP
                            const extraMatch = extraRelEntidad.find(p => p.toLowerCase() === rawValue.toLowerCase()) //Busca en custom list o lista extendida
                            const inputValue = baseMatch || labelMatch || extraMatch || rawValue.charAt(0).toUpperCase() + rawValue.slice(1).toLowerCase() // genera todas las posibles existencias

                            let rL = [...repLegales]
                            rL[indexRelated] = { ...rL[indexRelated], type: inputValue }
                            setShowListRelEntidad(false)
                            setRepLegales(rL)
                            setNewRelEntidad(null)

                            if (!baseMatch && !labelMatch && !extraMatch) {
                                setExtraRelEntidad(prev => [...prev, inputValue]) //Agrega nuevo input si el valor es verdaramente nuevo
                            }

                            if (form) {
                                form.setFieldsValue({ [`type_${indexRelated}`]: inputValue })
                                form.validateFields([`type_${indexRelated}`], { force: true })
                            }
                        }}
                        onCancel={() => {
                            setShowListRelEntidad(false)
                            if (form) {
                                form.setFieldsValue({ [`type_${indexRelated}`]: undefined })
                                form.validateFields([`type_${indexRelated}`], { force: true })
                            }
                        }}
                    >
                        <Input value={newRelEntidad} onChange={(e) => setNewRelEntidad(e.target.value)} placeholder={"Ej.: Director, Gerente"}/>
                    </Modal>
                }
                { showListTipoDoc &&
                    <Modal
                        title={t('messages.aml.documentTypeModalTitle')}
                        className="modal-area-cliente"
                        visible={ true }
                        width={ 400 }
                        onOk={() => {
                            const rawValue = newTipoDoc != null ? newTipoDoc.trim() : ''
                            if (!rawValue) return;

                            // Deduplicación case-insensitive: prioriza el valor ya existente
                            const baseMatch = [...TIPO_DOC_BASE].find(b => b.toLowerCase() === rawValue.toLowerCase())
                            const extraMatch = extraTipoDoc.find(p => p.toLowerCase() === rawValue.toLowerCase())
                            const inputValue = baseMatch || extraMatch || rawValue.charAt(0).toUpperCase() + rawValue.slice(1).toLowerCase()

                            let rL = [ ...repLegales ]
                            rL[indexTipoDoc] = { ...rL[indexTipoDoc], tipoDoc: inputValue }

                            if (rL[indexTipoDoc].tipoDoc?.toUpperCase() === 'RUT' && rL[indexTipoDoc].dni && currentUser.cliente.pais === "CHI") {
                                rL[indexTipoDoc].isValid = validateRutHelper(rL[indexTipoDoc].dni)
                            } else {
                                rL[indexTipoDoc].isValid = true
                            }

                            if (!baseMatch && !extraMatch) {
                                setExtraTipoDoc(prev => [...prev, inputValue])
                            }

                            setShowListTipoDoc(false)
                            setRepLegales(rL)
                            setNewTipoDoc(null)

                            if (form) {
                                form.setFieldsValue({ [`tipoDoc_${indexTipoDoc}`]: inputValue })
                                form.validateFields([`tipoDoc_${indexTipoDoc}`], { force: true })
                            }
                        }}
                        onCancel={() => {
                            setShowListTipoDoc(false)
                            setNewTipoDoc(null)
                            if (form) {
                                form.setFieldsValue({ [`tipoDoc_${indexTipoDoc}`]: undefined })
                                form.validateFields([`tipoDoc_${indexTipoDoc}`], { force: true })
                            }
                        }}
                    >
                    <Input value={newTipoDoc} onChange={(e) => setNewTipoDoc(e.target.value)} placeholder={t('messages.aml.documentTypeModalPlaceholder')}/>
                    </Modal>
                }
            </div>
        </Form>
    );
}

export default Form.create({ name: 'related_form' })(Relacionados);